import { render, staticRenderFns } from "./Gebäudeliste.vue?vue&type=template&id=5f2fb2ef&"
import script from "./Gebäudeliste.vue?vue&type=script&lang=js&"
export * from "./Gebäudeliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports